module.exports = __webpack_public_path__ + "img/img98.24c39ce4.png";